import clsx from "clsx";

import type { ReactNode } from "react";

export default function SettingsItemContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "flex border-t border-dotted w-full border-black-300 py-4 first:border-t-0",
        className,
      )}
    >
      {children}
    </div>
  );
}
